import {
  SignFilesFileSystemStrategy,
  SignFilesDeviceStrategy,
  SignFilesDepositSignLoginPswStrategy,
  SignFilesDiiaStrategy,
  SignFilesCloudKeyFileSystemStrategy,
  SignFilesWithQrCloudProviderStrategy,
  SignFilesWithIdCloudProviderStrategy
} from '@/sign/strategies/sign-files-private-key.strategy';
import { SignStrategyFactory } from './sign-strategy.factory';

export class SignFilesStrategyFactory extends SignStrategyFactory {
  constructor() {
    super(
      SignFilesFileSystemStrategy,
      SignFilesDeviceStrategy,
      SignFilesDepositSignLoginPswStrategy,
      SignFilesDiiaStrategy,
      SignFilesCloudKeyFileSystemStrategy,
      SignFilesWithQrCloudProviderStrategy,
      SignFilesWithIdCloudProviderStrategy);
  }
}
